import { Grid } from "@material-ui/core";
import React from "react";
import { useState } from "react";
import { CSVLink } from "react-csv";
import { Text, SVG, } from "sunrise-ui";
import EnlargeImage from "../../utilities/EnlargeImage";
import "./Reports.scss";

const displayDate = (dateString: string | number) => {
    if (dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleString("default", { month: "short" });
        const day = `0${date.getDate()}`.slice(-2);
        return `${day} ${month}, ${date.getFullYear()}`;
    }
    return "";
};

const displayDateAndTime = (dateString: string | number) => {
    if (dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleString("default", { month: "short" });
        const day = `0${date.getDate()}`.slice(-2);
        let hours = date.getHours();
        const MM = `0${date.getMinutes()}`.slice(-2);
        const AMPM = hours >= 12 ? 'pm' : 'am';
        hours = hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const HH = `0${hours}`.slice(-2);
        return `${day} ${month}, ${date.getFullYear()}, ${HH}:${MM} ${AMPM}`;
    }
    return "";
};

const DrawerRow = (props: any) => {

    const { header, value, format } = props;

    const data = format ? value : format?.toLocaleLowerCase() === 'date' ? displayDate(value) : format?.toLocaleLowerCase() === 'datetime' ? displayDateAndTime(value) : value;

    return (
        <Grid item xs={12}>
            <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
            >
                <span className="fw400">{header}</span>
                <span className="float-right">
                    {data}
                </span>
            </Text>
        </Grid>
    );
}

const BillDrawer = (props: any) => {

    const { drawerData, toggleDrawer } = props;
    const  [dataToDownload, setDataToDownload]  = useState<any>([]);
    //const [item, setItem] = useState('Cement');
    // ---------------for enlarge image modal-------------
    const [modalData, setModalData] = useState({
        image: "",
        isOpen: false,
    });
    React.useEffect(()=>{
        const downloadData = 
            {
                "Bill Reference Number":drawerData?.billReferenceNumber,
                "Bill Uploaded on": drawerData?.createdAt?.split("T")[0],
                "Deductions (C)": drawerData?.decuction,
                "Gross Bill Amount (D=A+A*B%C)(Rs)":drawerData?.grossBillAmount,
                "Item Name": drawerData?.items?.[0]?.itemName,
                "Quantity of Item": drawerData?.items?.[0]?.quantity,
                "Unit of Item": drawerData?.items?.[0]?.unit,
                "Basic Rate (Rs) of Item": drawerData?.items?.[0]?.basicAmount,
                "Amount of Item (A)(Rs)": drawerData?.items?.[0]?.itemAmount,
                "GST on Items (%)(B)": drawerData?.items?.[0]?.GST,
                "Deductions (C) for Item": drawerData?.items?.[0]?.deduction,
                "Description of Item": drawerData?.items?.[0]?.itemGrossAmount,
                "Bill Snapshot": drawerData?.billSnapshot,
            }

        setDataToDownload([downloadData])
    },[drawerData])
    const handleOpen = (photo: string) => {
        setModalData({ ...modalData, image: photo, isOpen: true });
    };
    const billDetailsData = [
        { header: 'Bill Uploaded on', value: drawerData?.createdAt?.split("T")[0], format: 'datetime' },
       // { header: 'Machine Details', value: 'JCB 112:K091234' },
        //{ header: 'Bill Date', value: '14 Jan 2022', format: 'date' },
        { header: 'Bill Reference Number', value: drawerData?.billReferenceNumber},
        //{ header: 'Basic Amoubt (A)(Rs)', value: '110' },
       // { header: 'GST on Items (%)(B)', value: '15' },
        { header: 'Deductions (C)', value: drawerData?.decuction },
        { header: 'Gross Bill Amount (D=A+A*B%C)(Rs)*', value: drawerData?.grossBillAmount},
    ]
    
    const itemDetailsData = [
        { header: 'Item Name', value: drawerData?.items[0]?.itemName},
        { header: 'Quantity of Item', value: drawerData?.items[0]?.quantity,},
        { header: 'Unit of Item', value: drawerData?.items[0]?.unit },
        { header: 'Basic Rate (Rs)', value: drawerData?.items[0]?.basicAmount },
        { header: 'Amount of Item (A)(Rs)', value: drawerData?.items[0]?.itemAmount},
        { header: 'GST on Items (%)(B)', value: drawerData?.items[0]?.GST },
        { header: 'Deductions (C)', value: drawerData?.items[0]?.deduction },
        { header: 'Gross Item Amount (D=A+A*B%C)(Rs)*', value: drawerData?.items[0]?.itemGrossAmount},
    ]
    const generateBillDetailFields = () => {
        return billDetailsData.map((item, index) => <DrawerRow key={`drawer_bill_field${index}`} header={item?.header} value={item?.value} format={item?.format} />)
    }

    const generateItemDetailFields = () => {
        return itemDetailsData.map((item, index) => <DrawerRow key={`drawer_bill_field${index}`} header={item?.header} value={item?.value} />)
    }

    return (
        <Grid>
            <div className="right_drawer_page">
                <Grid container className="drwaer_container p1">
                    <Grid item xs={11}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb1 mt0 capitalize"
                        >
                            {`Bill ${drawerData?.billReferenceNumber} Details`}
                        </Text>
                    </Grid>
                    <Grid
                        item
                        xs={1}
                        className="pointer"
                        onClick={() => toggleDrawer(false)}
                    >
                        <SVG type={"close"} />
                    </Grid>
                    {/* -----------------------Bill detail---------- ------------*/}
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb1 mt0"
                        >
                            Bill Details
                        </Text>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        container
                        spacing={1}
                        className="right_drawer_details_container"
                    >
                        {generateBillDetailFields()}
                    </Grid>
                    {/* -----------------------Item Details---------- ------------*/}
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb0 mt1"
                        >
                            Item Details
                        </Text>
                    </Grid>

                    {/* <Grid item xs={12}>
                        <SelectBox
                            data={[]}
                            placeHolder="Select Shift"
                            value={drawerData?.items[0]?.itemName}
                            defaultVal={item}
                            onChange={(e: any) => {
                                setItem(e.target.value);
                            }}
                            borderColor={"primary"}
                        />
                    </Grid> */}

                    <Grid
                        item
                        xs={12}
                        container
                        spacing={1}
                        className="right_drawer_details_container mt"
                    >
                        {generateItemDetailFields()}
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        container
                        spacing={1}
                        className="right_drawer_details_container pt1"
                    >
                        <DrawerRow header={'Description'} value={'Uploaded and Shared'} />
                    </Grid>

                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb1 mt1"
                        >
                            Bill Snapshot
                            <span className="float-right pointer">
                                <CSVLink data={dataToDownload} filename="Bill">
                                    <SVG type={"download"} isActive={true} />
                                </CSVLink>
                            </span>
                        </Text>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        container
                        spacing={1}
                        className="right_drawer_details_container"
                    >
                        <Grid item xs={5}>
                            <img
                                src={
                                    drawerData?.billSnapshot
                                }
                                alt="..."
                                className="drawer-photo pointer"
                                onClick={() => {
                                    handleOpen(
                                        drawerData?.billSnapshot
                                    );
                                }}
                            />
                        </Grid>
                    </Grid>

                </Grid>
            </div>
            {/* ---------------Enlarge Image Modal---------- */}
            <EnlargeImage modalData={modalData} />
        </Grid>
    );
};

export default BillDrawer;